import type { UnitCategory } from "verdi-common/Configurations/SensorConfigurations/SensorConfigurationTypes";
import type { DataViewerSpecOptions } from "@/features/data-viewer/spec/use-data-viewer-spec";

// Read together under the irrigation band: what the valves delivered, and what the soil took up.
const IRRIGATION_CATEGORIES: UnitCategory[] = ["liquidFlow", "liquidPressure", "volumetricSoilMoisture"];

export const ZONE_SPEC_OPTIONS: DataViewerSpecOptions = {
    irrigationBand: true,
    hideDiagnostics: true,
    // Listed first so their panel is the first one, which carries the band.
    unitCategoryPresentation: IRRIGATION_CATEGORIES.map((category) => ({ category })),
    panelRecipes: [{ left: IRRIGATION_CATEGORIES }],
};
